import type { JSX } from 'react';

import { FieldArray } from 'formik';

import { FormGroup } from '@admin-platform/ui/components';
import { FormLabel } from '@admin-platform/ui/components';

import { CustomSwitch } from '../CustomSwitch/CustomSwitch';
import ErrorMessageLabel from '../ErrorMessageLabel/ErrorMessageLabel';

import styles from './SwitchArray.module.css';

export interface SwitchArrayProps<ValueType> {
  options: { label: string; value: ValueType }[];
  values: ValueType[];
  label: string;
  name: string;
}

export default function SwitchArray(
  props: SwitchArrayProps<string>,
): JSX.Element {
  return (
    <FormGroup>
      <FormLabel htmlFor={props.name}>{props.label}</FormLabel>
      <FieldArray
        name={props.name}
        render={(arrayHelpers) => (
          <div>
            {props.options.map((option) => {
              const checked = props.values.includes(option.value);
              return (
                <div key={option.value} className={styles.Switch}>
                  <div>
                    <CustomSwitch
                      checked={checked}
                      onChange={(newChecked) => {
                        if (newChecked) {
                          arrayHelpers.push(option.value);
                        } else {
                          const idx = props.values.indexOf(option.value);
                          arrayHelpers.remove(idx);
                        }
                      }}
                    />
                  </div>
                  <div className={styles.Value}>{option.label}</div>
                </div>
              );
            })}
          </div>
        )}
      />

      <ErrorMessageLabel name={props.name} />
    </FormGroup>
  );
}
